import { createSlice } from '@reduxjs/toolkit';

import { initStateAuthUser, reducerAuthUser } from '../actions/user/authUser';
import { initStateCreateUser, reducerCreateUser } from '../actions/user/createUser';
import { initStateLoginEmail, reducerLoginEmail } from '../actions/user/loginEmail';
import { initStateAuthAdmin, reducerAuthAdmin } from '../actions/user/authAdmin';
import { initStateUserList, reducerUserList } from '../actions/user/userList';
import { initStateUserSingle, reducerUserSingle } from '../actions/user/userSingle';
import { initStateUpdateUser, reducerUpdateUser } from '../actions/user/updateUser';

export const initialState = {
  ...initStateAuthUser,
  ...initStateCreateUser,
  ...initStateLoginEmail,
  ...initStateAuthAdmin,
  ...initStateUserList,
  ...initStateUserSingle,
  ...initStateUpdateUser,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetAuthUser(state) {
      state.authUser = initStateAuthUser.authUser;
    },
    resetCreateUser(state) {
      state.createUser = initStateCreateUser.createUser;
    },
    resetLoginEmail(state) {
      state.loginEmail = initStateLoginEmail.loginEmail;
    },
    resetUserList(state, action) {
      state.userList = initStateUserList.userList;
    },
    resetUserSingle(state, action) {
      state.userSingle = initStateUserSingle.userSingle;
    },
    resetUpdateUser(state, action) {
      state.updateUser = initStateUpdateUser.updateUser;
    },
  },
  extraReducers: {
    ...reducerAuthUser,
    ...reducerCreateUser,
    ...reducerLoginEmail,
    ...reducerAuthAdmin,
    ...reducerUserList,
    ...reducerUserSingle,
    ...reducerUpdateUser,
  },
});
export const { resetUpdateUser, resetUserSingle, resetUserList, resetAuthUser, resetCreateUser, resetLoginEmail } = userSlice.actions;
export const userReducer = userSlice.reducer;
